export default __webpack_public_path__ + "static/media/ReportIcon-Kidneys-MS.946ff97b.jpg";